
//TODO s'hauria de pensar en utilitzar el codi del moment i no el string
//La primera posicio del array indica el valor per defecte de la resta de valors.
export const PERIODE_MATI = ['7h', 'en 24h', 'Acum dia pluviomètric'];
export const PERIODE_MIGDIA = ['13h'];
export const PERIODE_VESPRE = ['18h'];

export const ESTAT_OBSERVACIO_EDITABLE = 1;
export const ESTAT_OBSERVACIO_SENSE_OMPLIR = 2;

// Temps de retard de l'sppiner al fer actualitzacions
export const RETARD_MILISEGONS_APARICIO_SPINNER = 500;

// Nombre de decimals a mostrar a l'aplicació
export const numeroDeDecimalsCoordenades = 5;

export const textQuanNoHiHaDada = '--';
export const tipusCampNoSuportat = 'Tipus de camp no suportat';

export const alturaMissatgeErrorEnPixels = 80;
export const alturaNotificacioEnPixels = 80;

export const configuracioScrollIntoView = { behavior: 'smooth' };



// WEBPACK FOOTER //
// ./src/constants.js